/**
 * E-Prescriptions Feature
 *
 * Auto-registration and public exports for the e-prescriptions feature.
 * Enables electronic prescribing via DoseSpot integration.
 */

import { autoRegisterFeature } from '@store/features/factory';

import { eprescriptionsFeature } from './store/feature';

// Auto-register the feature when this module is imported
autoRegisterFeature(eprescriptionsFeature);

// Export store (all store-related exports)
export * from './store';

// Export components
export {
  EPrescriptionOrgSection,
  EPrescriptionOrgSetupModal,
  EPrescriptionPatientConnectModal,
  EPrescriptionUserSection,
} from './components';

// Export types
export * from './types';
